export const shouldDismissSportsSplash = ({ loading, loadedSport, activeSport }) => (
  loading === false
  && String(loadedSport || "").toUpperCase() === String(activeSport || "").toUpperCase()
);
